"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Returns an updated image url with resize parameters attached
 * You can specify exact dimensions in pixels for an image's
 * width and height, up to a maximum of 5760 x 5760 px. The image's
 * original aspect ratio will be preserved.
 *
 * @param {string} imageUrl The image url that needs updating
 * @param {number | null} width width of image
 * @param {number | null} height height of image
 * @return {string} Updated image string preserving aspect ratio
 *
 */
var shopifyResizeImage = function shopifyResizeImage(imageUrl, width, height) {
  var imageFormats = ['.jpg', '.jpeg', '.png', '.gif'];
  var updatedImageUrl = imageUrl;

  var buildResizeString = function buildResizeString() {
    if (width && height) return "_".concat(width, "x").concat(height);
    if (width && !height) return "_".concat(width, "x");
    if (height && !width) return "_x".concat(height);
    return '';
  };

  if (width || height) {
    imageFormats.forEach(function (format) {
      if (imageUrl !== null && imageUrl !== void 0 && imageUrl.includes(format)) {
        var i = imageUrl.lastIndexOf(format);
        updatedImageUrl = "".concat(imageUrl.slice(0, i)).concat(buildResizeString()).concat(imageUrl.slice(i));
      }
    });
  }

  return updatedImageUrl;
};

var _default = shopifyResizeImage;
exports["default"] = _default;